import { Injectable } from '@angular/core';
import { HttpService } from '../providers/http.service';
import { AppConfig } from '../app/app.config';

@Injectable()
export class ChangeService {

    constructor(
        private httpService: HttpService) { }
    //帐变记录
    getChangeRecord(obj) {
        var url = AppConfig.GetProdUrl()+ "/Report/Change?startDate="+obj.startDate+"&endDate="+obj.endDate+"&typeCode="+obj.typeCode+"&pageSize="+obj.pageSize+"&pageIndex="+obj.pageIndex+"&lotteryName="+obj.lotteryName+"&issueNo="+obj.issueNo+"&bettingId="+obj.bettingId+"&userName="+obj.userName;
        return this.httpService.get(url);
    }
    //团队帐变记录
    QueryTeamChange(userName,start, end, typecode, pageIndex: number, pageSize: number) {
        let param = "userName=" +userName +"&start="+start+"&end="+end + "&typecode=" + typecode +"&pageSize="+pageSize+"&pageIndex="+pageIndex;
        var url = AppConfig.GetProdUrl()+ "/Team/QueryTeamChange?"+param;
        return this.httpService.get(url);
    }
}


// WEBPACK FOOTER //
// ./src/services/change.service.ts